import { LucideIconName } from '@bm-js/atlascloud-shared'
import {
  Lightbulb,
  Link,
  List,
  ListChevronsDownUp,
  Newspaper,
  Calendar,
  Phone,
  FileText,
  ShieldCheck,
  Utensils,
  Mail,
  Images,
  CaseSensitive,
  Image,
  IdCardLanyard,
  ImagePlus,
  WalletCards,
  SquareArrowOutUpRight,
  TextAlignStart,
  Grid2X2Check,
  Crown,
  Tag,
  Film,
  LucideIcon,
  X,
  Sun,
  Drama,
  TreeDeciduous,
  Waves,
  Menu,
  Wine,
  Aperture,
  BriefcaseBusiness,
  Activity,
  BottleWine,
  Camera,
  Ship,
  Bed,
  Twitter,
  Instagram,
  Facebook,
  ArrowRight,
  CirclePlus,
  CircleX,
  ChevronRight,
  SquareArrowLeft,
  Trash2,
  Pen,
  Plus,
  CircleArrowDown,
  CircleArrowUp,
  Hand,
  Files,
  Settings,
  Smartphone,
  Laptop,
  SquarePen,
  CircleQuestionMark,
  Clapperboard,
  LockKeyhole,
  ChevronUp,
  ChevronDown,
  Keyboard,
  ArrowLeft,
  Presentation,
  PartyPopper,
  CircleCheck,
  Users,
  Megaphone,
  Gift,
  ShoppingCart,
  UserRoundCog,
  User,
  CircleUser,
  CornerRightDown,
  GripVertical,
  CornerLeftUp,
  Clock2,
} from 'lucide-react'

export const LucideIcons: Record<LucideIconName, LucideIcon> = {
  ListChevronsDownUp,
  Newspaper,
  Lightbulb,
  List,
  Link,
  Calendar,
  Phone,
  FileText,
  ShieldCheck,
  Utensils,
  Mail,
  Image,
  Images,
  ImagePlus,
  CaseSensitive,
  IdCardLanyard,
  WalletCards,
  SquareArrowOutUpRight,
  TextAlignStart,
  Grid2X2Check,
  Crown,
  Tag,
  Film,
  X,
  Menu,
  CircleX,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  SquareArrowLeft,
  Trash2,
  Pen,
  Plus,
  CircleArrowDown,
  CircleArrowUp,
  Hand,
  Files,
  Settings,
  Smartphone,
  Laptop,
  SquarePen,
  CircleUser,
  CornerRightDown,
  CornerLeftUp,
  GripVertical,
  CircleQuestionMark,
  Clapperboard,
  LockKeyhole,
  ArrowRight,
  ArrowLeft,
  Keyboard,
  CircleCheck,
  Users,
  Megaphone,
  Gift,
  ShoppingCart,
  UserRoundCog,
  CirclePlus,
  User,
  Twitter,
  Instagram,
  Facebook,
  Presentation,
  PartyPopper,
  Sun,
  Drama,
  Waves,
  TreeDeciduous,
  Ship,
  Bed,
  Wine,
  Activity,
  Aperture,
  BriefcaseBusiness,
  Camera,
  BottleWine,
  Clock2,
}
